import { TextGradientPrimaryBackground } from 'assets/colors/background';
import { BackgroundColor } from 'assets/colors/palette';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${BackgroundColor};

  div {
    ${TextGradientPrimaryBackground}
    text-align: start;

    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.75px;
  }
`;
